import { writable, get } from "svelte/store";
import { GiftService } from "$/services/GiftService";
import { BackgroundService } from "$/services/BackgroundService";
const GiftServiceImpl = (chrome === null || chrome === void 0 ? void 0 : chrome.storage) ? BackgroundService : GiftService;
export var PricingPlan;
(function (PricingPlan) {
    PricingPlan[PricingPlan["FREE"] = 0] = "FREE";
    PricingPlan[PricingPlan["PRO"] = 1] = "PRO";
})(PricingPlan || (PricingPlan = {}));
const store = () => {
    // create store
    const { subscribe, set, update } = writable(null);
    return {
        subscribe,
        set,
        update,
        getFreeGifts: (gifts) => {
            if (!gifts)
                return [];
            return gifts.filter((gift) => {
                return gift.pricingPlan === 0;
            });
        },
        getProGifts: (gifts) => {
            if (!gifts)
                return [];
            return gifts.filter((gift) => {
                return gift.pricingPlan === 1;
            });
        },
        getSentProGifts: (gifts) => {
            if (!gifts)
                return [];
            return gifts.filter((gift) => {
                return gift.pricingPlan === 1 && gift.recipient;
            });
        },
        init: async () => {
            set(null);
            let gifts = await GiftService.getGifts();
            set(gifts);
            return gifts;
        },
        /**
         * Sends gift to a particular recipient
         *
         * @throws Error if gift is not sent
         * @param gift
         */
        sendGift: async (gift) => {
            let newGift = await GiftServiceImpl.sendGift(gift);
            let gifts = get(GiftStore);
            // remove old gift
            gifts = gifts.filter((g) => {
                return g.id !== newGift.id;
            });
            // add new gift
            gifts.push(newGift);
            set(gifts);
        },
    };
};
export const GiftStore = store();
